import React from 'react';

const CookiePolicy = () => {
    return (
        <div className="bg-darkblue min-h-screen text-lightgray p-8">
            <div className="max-w-4xl mx-auto bg-bluegray p-8 rounded-lg shadow-lg">
                <h1 className="text-3xl font-bold text-orange mb-6">Cookie Policy</h1>
                <p className="mb-4">Last Updated: February 2026</p>

                <p className="mb-4">
                    Career Mission ("we", "our", or "us") uses cookies and similar tracking technologies (like local storage) to ensure our platform is secure, functional, and user-friendly.
                </p>

                <h2 className="text-xl font-bold text-white mt-6 mb-2">1. What are Cookies?</h2>
                <p className="mb-4">
                    Cookies are small text files stored on your device when you visit a website. "Local Storage" is a similar technology that allows us to save larger amounts of data (like your login session) directly in your browser.
                </p>

                <h2 className="text-xl font-bold text-white mt-6 mb-2">2. How We Use Them</h2>
                <p className="mb-4">We use these technologies for the following purposes:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                    <li><strong>Essential & Security:</strong> To keep you logged in, prevent fraud, and secure your payments (e.g., Stripe).</li>
                    <li><strong>Functionality:</strong> To remember your preferences and ensure our servers handle your requests efficiently (e.g., AWS Load Balancing).</li>
                </ul>

                <h2 className="text-xl font-bold text-white mt-6 mb-2">3. Specific Technologies We Use</h2>
                <div className="overflow-x-auto">
                    <table className="w-full text-left border-collapse mt-4">
                        <thead>
                            <tr className="border-b border-gray-600">
                                <th className="py-2 text-orange">Name/Source</th>
                                <th className="py-2 text-orange">Type</th>
                                <th className="py-2 text-orange">Purpose</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-700">
                            <tr>
                                <td className="py-2">Local Storage (token, user)</td>
                                <td className="py-2">Storage</td>
                                <td className="py-2">Maintains your login session so you don't have to sign in on every page.</td>
                            </tr>
                            <tr>
                                <td className="py-2">Stripe (__stripe_mid, etc.)</td>
                                <td className="py-2">Cookie</td>
                                <td className="py-2">Fraud prevention and payment processing security.</td>
                            </tr>
                            <tr>
                                <td className="py-2">AWS (AWSELB)</td>
                                <td className="py-2">Cookie</td>
                                <td className="py-2">Load balancing (ensures your request hits the right server).</td>
                            </tr>
                            <tr>
                                <td className="py-2">Google Auth</td>
                                <td className="py-2">Third-Party</td>
                                <td className="py-2">Facilitates "Sign in with Google" functionality.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h2 className="text-xl font-bold text-white mt-6 mb-2">4. Managing Your Preferences</h2>
                <p className="mb-4">
                    Most web browsers allow you to control cookies through their settings preferences. However, if you limit the ability of websites to set cookies, you may worsen your overall user experience, since it will no longer be personalized to you.
                </p>

                <h2 className="text-xl font-bold text-white mt-6 mb-2">5. Contact Us</h2>
                <p>
                    If you have questions about our use of cookies, please contact us at support@careermission.ai.
                </p>
            </div>
        </div>
    );
};

export default CookiePolicy;